export const clearTel = (tel: string) => {
  const reg = /^\d+$/;
  return tel.replace(reg, "");
};
